import type { ReactNode } from "react";
import styles from "./Tag.module.css";

interface TagProps {
  children: ReactNode;
  className?: string | undefined;
}

/**
 * Small label pill on `surface-raised` with a Caption 2 font. Used for wind
 * directions in the spot card / detail header. Figma node 12:2405.
 */
export function Tag({ children, className }: TagProps) {
  return (
    <span className={[styles.tag, className].filter(Boolean).join(" ")}>
      {children}
    </span>
  );
}
